import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=7088aaa1&scoped=true"
import script from "./Metadata.vue?vue&type=script&lang=js"
export * from "./Metadata.vue?vue&type=script&lang=js"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=7088aaa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088aaa1",
  null
  
)

export default component.exports